import { Link } from "react-router-dom";
import LaxmiLogo from "../../../assets/laxmi.svg";
import Input from "../../../components/input";
import "./login.scss";
import Button from "../../../components/button";
import { useDispatch, useSelector } from "react-redux";
import { enterPage, loginAction, loginData } from "../../../stores/auth";
import { useEffect, useState } from "react";

const LoginPage = () => {
    const dispatch = useDispatch();
    const { status, error } = useSelector(loginData);
    const [form, setForm] = useState({ email: "", password: "" });

    useEffect(() => {
        dispatch(enterPage());
    }, [dispatch]);

    const handleChange = (e) => {
        const { value, id } = e.target;
        setForm({
            ...form,
            [id]: value
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(loginAction(form));
    }

    const isFormValid = form.email && form.password;

    return (
        <div className="login-container">
            <div className="column-center-black">
                <img src={LaxmiLogo} className="login-logo" alt="Logo" />
            </div>
            <div className="column-center-white">
                <div className="login-form-container">
                    <div className="login-header">
                        <h2>Welcome!</h2>
                        <p className="sub-title">Please login to your account</p>
                    </div>
                    
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <Input 
                                id="email" 
                                onChange={handleChange} 
                                label="Email" 
                                type="email" 
                                placeholder="Enter email" 
                            />
                        </div>
                        
                        <div className="form-group">
                            <Input 
                                id="password" 
                                onChange={handleChange} 
                                label="Password" 
                                type="password" 
                                placeholder="Enter password" 
                            />
                        </div>
                        
                        <div className="forgot-password">
                            <Link to="/auth/forgot" className="forgot-link">
                                Forgot Password?
                            </Link>
                        </div>
                        
                        <div className="form-group">
                            <Button 
                                className="login-button" 
                                title="Login" 
                                isLoading={status === 'loading'} 
                                disabled={!isFormValid}
                                type="submit"
                            />
                        </div>
                        
                        {status === 'failed' && (
                            <div className="error-message">
                                {error?.message || 'Login failed. Please try again.'}
                            </div>
                        )}
                        
                        {status === 'succeeded' && (
                            <div className="success-message">
                                Login successful!
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;